<template>
  <main class="main create_estimate_common" role="main">
    <div class="main_con">
      <!-- <div class="step">
        <div class="point on"></div>
        <div class="step_txt">Step1. 견적요청</div>
      </div> -->
      <!-- 스텝바 -->
      <div class="step_bar">
        <div class="bar">
          <div class="state" :style="{ width: `${widthLine}%` }"></div>
        </div>
      </div>

      <!-- step 1-->
      <div class="step_qa" v-if="currentStep === 1">
        <div class="question">
          <img
            class="skylife"
            :src="require(`@/assets/front/images/new/logo_kt_skylife.png`)"
            alt=""
          />
          견적을 받아보실<br />
          요금제를 선택해주세요.
        </div>
        <div class="answer_wrap check_table skylife">
          <label v-for="item in plans" :key="item.planName">
            <input
              type="radio"
              name="ic_1"
              v-model="selectedPlan"
              :value="item"
            />
            <div class="txt"></div>
            <div class="txt02">
              {{ item.planName }}
              <span>*3년 약정 기준</span>
            </div>
            <div class="option">
              <img
                :src="require(`@/assets/front/images/new/${item.png}`)"
                alt=""
              />
            </div>
            <div class="price">
              <strike>월 {{ item.originPrice | comma }}원</strike>
              <span
                >월<span class="red"> {{ item.discountPrice | comma }}</span
                >원</span
              >
              <p>{{ item.desc }}</p>
            </div>
          </label>
        </div>
      </div>

      <!-- STEP 2 -->
      <div class="step_qa" v-if="currentStep == 2">
        <div class="question">
          인터넷 설치하실 동네를 선택해 주세요!
        </div>
        <div class="answer_wrap" data-columns="">
          <label class="area select" @click="goSelectArea">
            <button>
              선택 주소 : {{ area.name }}<span class="i_drop"></span>
            </button>
          </label>
        </div>
      </div>

      <!-- STEP 3 -->
      <div class="e_step_qa" v-if="currentStep == 3">
        <div class="question">
          입력하신 정보가 맞다면,<br />이제 견적을 받아볼까요?
        </div>
        <div class="result_wrap skylife">
          <div class="result_inner">
            <div class="list">
              <div class="txt">개통구분</div>
              <div class="txt02">{{ data.joinType }}</div>
            </div>
            <div class="list">
              <div class="txt">희망업체</div>
              <div class="txt02">
                {{ data.telecom }}
              </div>
            </div>
            <div class="list">
              <div class="txt">희망속도</div>
              <div class="txt02">{{ selectedPlan.speed }}</div>
            </div>
            <div class="list">
              <div class="txt">희망상품</div>
              <div class="txt02">{{ selectedPlan.planName }}</div>
            </div>
            <div class="list">
              <div class="txt">설치주소</div>
              <div class="txt02">{{ area.fullName }}</div>
            </div>
          </div>
          <div class="result_inner" style="margin-top: 1rem">
            <div class="list">
              <div class="txt">요금제명</div>
              <div class="txt02">{{ selectedPlan.planName }}</div>
            </div>
            <div class="list">
              <div class="txt">월 요금</div>
              <div class="txt02">
                {{ selectedPlan.discountPrice | comma }}원
                <p>{{ selectedPlan.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 안내사항 -->
    <div class="btm_form_info ic" v-if="currentStep == 3">
      <div class="info_img">
        <img
          :src="require('@/assets/front/images/new/img_txt_noti_hand.png')"
          alt=""
        />
      </div>
      <div class="info_txt">
        <div>견적 요청 후 일주일간 수정 및 재등록이 불가합니다!</div>
      </div>
    </div>

    <!-- 이전버튼 -->
    <div class="ic_back" v-if="currentStep == 2" @click="goPrev">
      <img
        :src="require(`@/assets/front/images/mobile/ic_float_pre.svg`)"
        alt=""
      />
    </div>

    <!-- 다음버튼 -->
    <div class="ic_next" v-if="currentStep != 3" @click="goNext">
      다음
      <img
        :src="require(`@/assets/front/images/mobile/ic_float_nxt_w.svg`)"
        alt=""
      />
    </div>

    <div class="btm_btn" v-if="currentStep == 3">
      <div class="btn_wrap">
        <button class="btn bo" @click="goPrev">
          뒤로가기
        </button>
        <button class="btn" @click="sendInternet">
          신청하기
        </button>
      </div>
    </div>

    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="bottom: 5rem;"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>

    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'confirm',
        msg: `작성하신 정보는 전국의 매장에게<br />노출되며,
    매장에서 내용 확인 후<br />다양한 혜택을 보내 드릴 예정입니다.<br /><br /><span
      style='color:#757575;font-size:1.2rem;'
      >※카카오 알림톡으로 진행사항을 알려드려요!</span
    >`,
      }"
      @close="popupClose"
    />
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import format from 'date-fns/format';

export default {
  name: 'ineternetcommerce-skylife',
  description: 'kt skylife 가입 혜택 알아보기',
  components: { DesignPopup2 },
  data() {
    return {
      promotionCode: 'SKYLIFE_DIRECT',
      currentStep: 1,
      widthLine: 33.3,
      area: {
        name: '',
        fullName: '',
      },
      data: {
        joinType: '가입(변경)',
        telecom: 'KT Skylife',
        itemUse: '',
        speed: '',
        phoneJoin: 'NONE',
        currentTelecom: 'KT Skylife',
      },
      selectedPlan: '',
      plans: [
        {
          planName: 'Sky all + sky 100M',
          speed: '100M',
          originPrice: 28600,
          discountPrice: 19800,
          desc: '(부가세 포함, 수신기·AP 임대료 월 2,200원 별도)',
          png: 'img_sky_all_100.png',
        },
        {
          planName: 'Sky all + sky 기가 200M',
          speed: '200M',
          originPrice: 30800,
          discountPrice: 22000,
          desc: '(부가세 포함, 수신기 임대료 월 1,100원 별도)',
          png: 'img_sky_all_200.png',
        },
      ],
      isViewToast: false,
      errorMessage: '',
      designPopup: false,
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
    }),
  },
  async created() {
    let goCreateCheck = true;
    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

    // 인터넷 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 2건)
    if (this.internetCommerceIngList.content.length >= 2) {
      goCreateCheck = false;
    } else if (this.internetCommerceIngList.content.length == 1) {
      if (this.internetCommerceEndList.content.length >= 1) {
        const createdAt = new Date(
          this.internetCommerceEndList.content[0].createdAt,
        );

        const sDays = format(
          new Date(createdAt.setDate(createdAt.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        // 안지났음
        if (now < sDays) {
          goCreateCheck = false;
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
    } else if (this.internetCommerceIngList.content.length == 0) {
      if (this.internetCommerceEndList.content.length >= 2) {
        const createdAt_1 = new Date(
          this.internetCommerceEndList.content[0].createdAt,
        );

        const sDays_1 = format(
          new Date(createdAt_1.setDate(createdAt_1.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        const createdAt_2 = new Date(
          this.internetCommerceEndList.content[1].createdAt,
        );

        const sDays_2 = format(
          new Date(createdAt_2.setDate(createdAt_2.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        // 둘다 안지났음
        if (now < sDays_1 && now < sDays_2) {
          goCreateCheck = false;
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
    } else {
      goCreateCheck = true;
    }

    if (!goCreateCheck) {
      this.$router.push({ path: '/' }).catch(err => {});
    }

    // const planType = this.$route.params.planType;
    // if (planType !== '') this.selectedPlan = this.plans[planType];

    await this.getMyProfile();
    await this.getInternetInfo();
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.CREATE_INTERNET_PROMOTION_SUBMIT,
      internetTypes.SELECT_INTERNET_COMMERCE_QUOTATION_CNT_CHECK,
    ]),
    async getMyProfile() {
      await this[userTypes.FETCH_ME]();
    },
    async getInternetCommerceCntCheck() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_QUOTATION_CNT_CHECK]({
        icId: this.$route.query.id,
      });
      console.log(
        'getInternetCommerceCntCheck :: {}',
        this.internetCommerceCheckCnt,
      );
      if (this.internetCommerceCheckCnt == 1) {
        this.$router.push({ name: 'Home' });
      }
    },
    goPrev() {
      this.updateStatus(false);

      this.currentStep--;

      localStorage.setItem('skylifeStep', this.currentStep);
    },
    goNext() {
      if (this.currentStep === 1 && !this.selectedPlan) {
        this.errorMessage = '요금제를 선택해주세요';
        this.toastView();
        return;
      }

      this.currentStep++;
      this.updateStatus(true);
      localStorage.setItem('skylifePlan', JSON.stringify(this.selectedPlan));
      localStorage.setItem('skylifeStep', this.currentStep);
    },
    updateStatus(isNext) {
      // widthLine: 33.3 > 66.6 > 100
      const width = 33.3;
      if (isNext) {
        if (this.currentStep !== 3) {
          this.widthLine += width;
        } else {
          this.widthLine = 100;
        }
      } else {
        if (this.currentStep !== 3) {
          this.widthLine -= width;
        } else {
          this.widthLine = 66.6;
        }
      }
    },
    getInternetInfo() {
      const skylifeStep = localStorage.getItem('skylifeStep');
      const skylifePlan = localStorage.getItem('skylifePlan');
      let skylifeArea = localStorage.getItem('skylifeArea');

      if (skylifeStep) this.currentStep = Number(skylifeStep);

      if (this.currentStep === 2) {
        this.selectedPlan = JSON.parse(skylifePlan);
      } else {
        localStorage.removeItem('skylifePlan');
        localStorage.removeItem('skylifeStep');
        localStorage.removeItem('skylifeArea');
        this.currentStep = 1;
      }

      if (skylifeArea) {
        skylifeArea = JSON.parse(skylifeArea);
        this.area.name = skylifeArea.areaName;
        this.area.fullName = skylifeArea.areaFullName;
      } else {
        this.area.name = this.user.emdAreaNameShort;
        this.area.fullName = this.user.emdAreaName;
      }
    },
    goSelectArea() {
      let codeType = 'e';
      let areaId = this.user.emdAreaId;
      if (this.user.admName) {
        const admArea = JSON.parse(this.user.admName);
        areaId = admArea.id;
        codeType = 'a';
      }
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          areaName: this.user.emdAreaName.substring(
            this.user.emdAreaName.lastIndexOf(' ') + 1,
          ),
          areaFullName: this.user.emdAreaName,
          areaId,
          codeType,
          from: 'Skylife',
        },
      });
    },
    sendInternet() {
      this.designPopup = true;
    },
    popupClose(checked) {
      if (checked) {
        let params = { ...this.data };
        params.promotionCode = this.promotionCode;
        params.itemUse = this.selectedPlan.planName;
        params.speed = this.selectedPlan.speed;
        params.areaFullName = this.area.fullName;
        params.areaName = this.area.name;
        params.userId = this.user.id;

        this[internetTypes.CREATE_INTERNET_PROMOTION_SUBMIT](params).then(
          () => {
            util.sdk_logEvent('INTERNET_ESTIMATE', {
              user_id: this.user.id,
              promotion: this.promotionCode,
            });

            util.sdk_logEventKakao('INTERNET_ESTIMATE');

            this.designPopup = false;
            localStorage.removeItem('skylifePlan');
            localStorage.removeItem('skylifeStep');
            localStorage.removeItem('skylifeArea');

            this.$router.push({
              name: 'InternetCommerce.List',
            });
          },
        );
      }

      this.designPopup = false;
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
  },
};
</script>

<style></style>
